<template>
  <div :class="[$style.wrapper, white && $style.white, character === 'boy' && $style.boy]" :style="width && {width: `${width}%`}">
    <template v-if="!hideButton">
      <button v-if="!showPopup" :class="$style.helpButton" @click="$emit('open')">Нужна помощь?</button>
    </template>
    <transition name="only-fade">
    <div v-if="showPopup" :class="$style.helpPopup">
      <div :class="$style.helpBox" :style="width && {width: `${width}%`}">
        <div v-if="showHeader" :class="$style.helpBox__header">
          <img :src="require(`@/assets/icons/${icon}`)" :style="{ width: icon === 'success.svg' ? '3.2rem' : '3.7rem' }"/>
          <span>{{title}}</span>
        </div>
        <span :class="$style.helpBox__description" v-html="description"></span>
        <button :class="$style.helpBox__button"  @click="buttonClick">{{buttonText}}</button>
      </div>
      <img :class="$style.character" :src="getCharImg" />
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HelpBox',
  props: {
    type: String,
    description: String,
    show: Boolean,
    hideButton: Boolean,
    character: String,
    warnMessage: String,
    white: Boolean,
    width: [Number, String],
  },
  computed: {
    showHeader() {
      return this.type !== 'task'
    },
    icon() {
      return this.type === 'warning' ? 'warning.svg' : 'success.svg'
    },
    title() {
      return this.type === 'warning' ? 'Ошибка!' : 'Молодец'
    },
    buttonText() {
      if (this.type === 'warning') {
        return this.warnMessage || 'Выбери другой способ связи!'
      } if (this.type === 'success') {
        return 'Продолжить'
      }
      return 'ОК'
    },
    getCharImg() {
      if (this.character) {
        return this.character === 'boy'
          ? require('@/assets/boy.svg')
          : require('@/assets/girl.png')
      }
      return require('@/assets/girl.png')
    },
  },
  watch: {
    show() {
      this.showPopup = this.show
      clearTimeout(this.timeoutHandle)
      if (this.type === 'warning') this.closeWarning()
    },
    type() {
      clearTimeout(this.timeoutHandle)
      if (this.type === 'warning') this.closeWarning()
    },
  },
  data: () => ({
    showPopup: false,
  }),
  methods: {
    buttonClick() {
      clearTimeout(this.timeoutHandle)
      this.$emit('close')
      if (this.type === 'success') {
        this.$emit('showNextTask')
      } else if (this.type === 'warning') {
        this.$emit('closeWarning')
      }
    },
    closeWarning() {
      this.timeoutHandle = setTimeout(() => {
        if (!this.showPopup) return
        this.$emit('close')
        this.$emit('closeWarning')
      }, 5000)
    },
  },
}
</script>

<style lang="scss" module>
  @import './HelpBox.scss';
</style>
